var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragoonRightLegBtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 38,
    width: 1,
    height: 1,
    fill: "#725B2B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 1,
    height: 1,
    fill: "#8D7136"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A88B47"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 39,
    width: 1,
    height: 1,
    fill: "#725B2B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 1,
    height: 1,
    fill: "#8D7136"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39,
    width: 1,
    height: 1,
    fill: "#A88B47"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 39,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 1,
    height: 1,
    fill: "#725B2B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 40,
    width: 1,
    height: 1,
    fill: "#A88B47"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 40,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 40,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 41,
    width: 1,
    height: 1,
    fill: "#725B2B"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 41,
    width: 1,
    height: 1,
    fill: "#A88B47"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 41,
    width: 1,
    height: 1,
    fill: "#B59147"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 41,
    width: 1,
    height: 1,
    fill: "#A88B47"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 42,
    width: 1,
    height: 1,
    fill: "#725B2B"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A88B47"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 42,
    width: 1,
    height: 1,
    fill: "#B59147"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragoonRightLegBtm);
export default __webpack_public_path__ + "static/media/dragoon-RightLegBtm.eaeb972a55b94514710c093dafeb380e.svg";
export { ForwardRef as ReactComponent };